<div class="mt-2 flex bg-white px-5 pt-4 rounded-xl">

  <span class="text-sm font-semibold mt-3 mr-16">{{'data-sharing.activity' | translate}}</span>

  <div class="flex flex-col">

    <div class="flex mb-3">
      <div *ngIf="isAlwaysButtonVisible" (click)="onAlways()"
           [ngClass]="{'cursor-pointer': !isViewMode,
                    'tk-border-transparent tk-bg-blue bg-blue-dark-hover text-white': isAlwaysSelected,
                    'tk-border-gray-2 bg-transparent': !isAlwaysSelected}"
           class="mr-2 mt-2 rounded-full bg-transparent">
        <div class="mx-4 my-2">{{'labels.always' | translate | titlecase}}</div>
      </div>

      <div *ngIf="isDateRangeButtonVisible" (click)="onDateRangeSelected()"
           [ngClass]="{'cursor-pointer': !isViewMode,
                    'tk-border-transparent tk-bg-blue bg-blue-dark-hover text-white': isDateRangeButtonSelected,
                    'tk-border-gray-2 bg-transparent': !isDateRangeButtonSelected}"
           class="mr-2 mt-2 rounded-full bg-transparent">
        <div class="mx-4 my-2">{{'data-sharing.in-given-time' | translate}}</div>
      </div>
    </div>

    <div *ngIf="isDateRangeButtonSelected" [formGroup]="form" class="flex align-middle">
      <mat-form-field appearance="outline" class="w-52 mr-3">
        <mat-label>{{'data-sharing.active-from' | translate}}</mat-label>
        <input matInput [ngxMatDatetimePicker]="$any(startDatePicker)" formControlName="startDate"
               [min]="minDate" [disabled]="isViewMode" [readonly]="true">
        <mat-error *ngIf="startDateCtrl.invalid" id="{{getErrorMessageElementId('startDate', startDateCtrl)}}">
          {{getErrorMessage(startDateCtrl)}}
        </mat-error>
        <mat-datepicker-toggle matSuffix [for]="$any(startDatePicker)">
          <div matDatepickerToggleIcon class="tk-i-date-time-picker w-4 h-4"></div>
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #startDatePicker>
          <ng-template>
            <span id="btn-from-apply">{{'labels.apply' | translate | titlecase}}</span>
          </ng-template>
        </ngx-mat-datetime-picker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-52">
        <mat-label>{{'data-sharing.active-to' | translate}}</mat-label>
        <input matInput [ngxMatDatetimePicker]="$any(pickerEndDate)" formControlName="endDate"
               [min]="minDate" [disabled]="isViewMode" [readonly]="true">
        <mat-error *ngIf="endDateCtrl.invalid" id="{{getErrorMessageElementId('endDate', endDateCtrl)}}">
          {{getErrorMessage(endDateCtrl)}}
        </mat-error>
        <mat-datepicker-toggle matSuffix [for]="$any(pickerEndDate)">
          <div matDatepickerToggleIcon class="tk-i-date-time-picker w-4 h-4"></div>
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerEndDate>
          <ng-template>
            <span id="btn-to-apply">{{'labels.apply' | translate | titlecase}}</span>
          </ng-template>
        </ngx-mat-datetime-picker>
      </mat-form-field>

    </div>
  </div>
</div>
